import { request } from '_api/client'

export const getToken = async () => {
    const params = {
        username: process.env.VUE_APP_USERNAME,
        password: process.env.VUE_APP_PASSWORD,
    }
    try {
        const response = await request('POST', 'user/auth/login/', params)
        const { token } = response

        if (token) {
            localStorage.setItem('AccessToken', token)
        } else {
            localStorage.removeItem('AccessToken')
        }
    } catch (e) {
        localStorage.removeItem('AccessToken')
    }
}
